var image_cards = document.querySelectorAll('.card-slider-wrapper')

image_cards.forEach( e=> {

    e.addEventListener('scroll', (el)=> {
        var scrollPercentage = 100 * el.target.scrollLeft / (el.target.scrollWidth-el.target.clientWidth);
        var parent = el.target.closest('.grid-product__content')
        
        parent.querySelector('.progress-color').style.transform = 'translateX(' + Math.floor(scrollPercentage) + '%)';
    });

    // var cards = e.querySelectorAll('.card-slide')
    // e.scrollBy({
    //     left: cards[0].clientWidth,
    //     behavior: 'smooth'
    // });
})